import React from 'react'
import PropTypes from 'prop-types'
import ClampedText from '../ClampedText'
import styles from './HeadingAndText.icss'

const HeadingAndText = ({ heading, text }) => (!!(heading || text) && (
	<section className={[styles.section, styles.pagePadding].join(' ')}>
		<h2 className={styles.itemHeadingText}>{heading}</h2>
		{text && (
			<ClampedText>
				{text}
			</ClampedText>
		)}
	</section>
))

HeadingAndText.propTypes = {
	heading: PropTypes.string,
	text: PropTypes.string
}

HeadingAndText.defaultProps = {
	heading: undefined,
	text: undefined
}

export default HeadingAndText



// WEBPACK FOOTER //
// ./src/components/Item/HeadingAndText.jsx